
import { defineComponent } from 'vue';
import { adService } from '../AdService';

export default defineComponent({
  name: 'AdImage',
  props: {
    adGuid: String,
    estateType: {
      type: Number,
      required: true,
    },
    estateSubType: {
      type: Number,
      required: true,
    },
    file: String,
    alt: String,
    height: Number,
    width: Number,
    rmode: String,
    hrmode: String,
    wrmode: String,
    bgcolor: String,
    watermark: {
      type: Boolean,
      default: true,
    },
    backgroundImage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isPlaceholder() {
      return !this.file;
    },
    src: function () {
      const item = this as any;
      return adService.getImageOrPlaceHolder(item.adGuid, this.estateType, this.estateSubType, item.file, {
        height: item.height,
        width: item.width,
        rmode: item.rmode,
        hrmode: item.hrmode,
        wrmode: item.wrmode,
        bgcolor: item.bgcolor,
        watermark: item.watermark,
      });
    },
  },
});
